<template lang="html">
  <div class="layout-div__container clearfix">
    <div class="layout-div__title">
      <span class="layout-span__title__text">
        <i class="layout-i__line"></i>痘痘
      </span>
    </div>
    <div class="layout-div__body">
      <div class="sr-div__acne">
        <div class="sr-div__acne__result">
          <div class="sr-div__acne__progress">
            <div class="sr-div__acne__red" :style="'position:absolute;bottom: 70%;height:'+acneLevel.red.height+'%;'+ (!!acneLevel.red.appear ? 'background-color:#f0f0f0;':'')"></div>
            <div class="sr-div__acne__deepgreen" :style="'position:absolute;bottom:30%;height:'+acneLevel.deepgreen.height+'%;'+(!!acneLevel.deepgreen.appear? 'background-color:#f0f0f0;':'')"></div>
            <div class="sr-div__acne__lightgreen" :style="'position:absolute;bottom:0;height:'+acneLevel.lightgreen.height+'%;'+(!!acneLevel.lightgreen.appear? 'background-color:#f0f0f0;':'')"></div>
          </div>
          <img v-if="acneLevel.acne.length !== 0" class="level-img" :src="levelImg" alt="程度" :style="'bottom:' + levelHeight + '%;'" />
          <span class="sr-div__acne__bottom"></span>
        </div>
        <div style="position:relative;display:block;height:220px;width: 175px;margin-left: 16%;float: right;">
          <img v-for="(item, index) in acneLevel.acne" :key="index" :src="item.img" :style="'position:absolute;left:'+item.loct[0]+'px;top:'+item.loct[1]+'px;z-index: 999; width:'+(2+item.severity*4)/7.5+'vw;'">
          <img src="./imgs/record-image-face@2x.png" style="width:100%;" alt="" id="acneImage">
        </div>
      </div>
      <ul class="sr-ul__result__group clearfix">
        <li style="margin-top:5px;">
          {{acneLevel.acneAdvice}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  beforeMount () {
    let {
      short_acne_advice,
      acne_severity,
      acne
    } = this.$store.state.result.resultData
    this.handleAcne(acne, short_acne_advice, acne_severity)
  },
  methods: {
    handleAcne (acne, advice, severity) {
      if (acne.length === 0) {
        this.acneLevel = {
          lightgreen: {
            height: 0,
            appear: false
          },
          deepgreen: {
            height: 0,
            appear: false
          },
          red: {
            height: 0,
            appear: false
          },
          acne: [],
          acneAdvice: advice,
          severity: severity
        }
        this.levelImg = ''
      } else {
        severity = parseInt(severity * 100)
        var lightgreen, deepgreen, red
        var lightgreen_boolean, deepgreen_boolean, red_boolean
        if (severity < 30) {
          lightgreen = severity
          lightgreen_boolean = false
          deepgreen = 40
          deepgreen_boolean = true
          red = 30
          red_boolean = true
          this.levelImg = require('./imgs/light@2x.png')
          this.levelHeight = lightgreen - 7
        } else if (severity > 30 && severity < 70) {
          lightgreen = 30
          lightgreen_boolean = false
          deepgreen = severity - 30
          deepgreen_boolean = false
          red = 30
          red_boolean = true
          this.levelImg = require('./imgs/mmedium@2x.png')
          this.levelHeight = lightgreen + deepgreen - 7
        } else {
          lightgreen = 30
          lightgreen_boolean = false
          deepgreen = 40
          deepgreen_boolean = false
          red = severity - 70
          red_boolean = false
          this.levelImg = require('./imgs/heavy@2x.png')
          this.levelHeight = lightgreen + deepgreen + red - 7
        }
        var acnes = acne
        for (var i = 0, len = acnes.length; i < len; i++) {
          acnes[i].img = require(`./imgs/report-icon-acne-${acnes[i].severity}@2x.png`)
          acnes[i].loct[0] = 171 - (acnes[i].loct[0] + 36) * (171 / 473)
          acnes[i].loct[1] = (acnes[i].loct[1] + 42) * (171 / 473)
        }
        this.acneLevel = {
          lightgreen: {
            height: lightgreen,
            appear: lightgreen_boolean
          },
          deepgreen: {
            height: deepgreen,
            appear: deepgreen_boolean
          },
          red: {
            height: red,
            appear: red_boolean
          },
          acne: acnes,
          acneAdvice: advice,
          totalSeverity: parseInt(this.acneLevel.totalSeverity * 100)
        }
      }
    }
  },
  data () {
    return {
      levelImg:'',
      acneLevel: {
        lightgreen: {
          height: 30,
          appear: false
        },
        deepgreen: {
          height: 40,
          appear: false
        },
        red: {
          height: 30,
          appear: false
        },
        acne: [],
        acneAdvice: '',
        totalSeverity: 0
      }
    }
  }
}
</script>

<style scoped>
  .sr-div__acne {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: 5.3vw;
  }
  .sr-ul__result__group {
    margin: 0;
    padding: 0;
    display: block;
    list-style: none;
    margin-top: 8vw;
    font-size: 15px;
  }
  .sr-ul__result__group li {
    font-family: 'PingFangSC';
  }
  .sr-div__acne__result {
    width: 32%;
    min-height: 134px;
    position: relative;
    margin-left: 4.5%;
    margin-top: 20%;
    margin-bottom: 8%;
  }
  .sr-div__acne__bottom {
    width: 100%;
    height: 2px;
    background-color: #d8d8d8;
    display: block;
    position: absolute;
    bottom: 0;
  }
  .sr-div__acne__progress {
    position: absolute;
    width: 8.3333%;
    height: 134px;
    bottom: 1.3158%;
    overflow: hidden;
    background-color: #f0f0f0;
    left: 50%;
    margin-left: -5px;
  }
  .sr-div__acne__red {
    width: 100%;
    height: 40px;
    display: block;
    background: #ff3c00;
  }
  .sr-div__acne__deepgreen {
    width: 100%;
    height: 54px;
    display: block;
    background: #32a0a0;
  }
  .sr-div__acne__lightgreen {
    width: 100%;
    height: 40px;
    display: block;
    background: #64c8c8;
  }
  .level-img{
    width: 10.4vw;
    height:5.333333333vw;
    bottom: 0;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/Result/pimple.vue